import { LoadingButton } from '@mui/lab';
import { Box, useTheme } from '@mui/system';
import { DEV_REV_DISABLED_ROUTES } from 'constants/routes';
import { useLowResolution } from 'hooks';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { ITheme } from 'types/theme';

const HORIZONTAL_OFFSET = 10;
const BOTTOM_OFFSET = 18;

interface IDevRevButtonProps {
	onClick: () => void;
	isLoading?: boolean;
}

const DevRevButton: React.FC<IDevRevButtonProps> = ({ onClick, isLoading }) => {
	const {
		assets: { general }
	} = useTheme<ITheme>();
	const { pathname } = useLocation();
	const lowRes = useLowResolution();
	const hidden = DEV_REV_DISABLED_ROUTES.includes(pathname) || lowRes;

	return (
		<Box
			display={hidden ? 'none' : ''}
			data-testid="support-widget"
			position="absolute"
			left={HORIZONTAL_OFFSET}
			bottom={BOTTOM_OFFSET}
			zIndex={1212}
		>
			<LoadingButton
				data-testid="support-widget-button"
				aria-label="support-widget-button"
				onClick={onClick}
				loading={isLoading}
				disabled={isLoading}
				style={{
					borderRadius: '100%'
				}}
			>
				{isLoading ? null : (
					<img
						id="support-widget-bubble"
						src={general.DevRevBubble()}
						alt="support-widget-button-icon"
					/>
				)}
			</LoadingButton>
		</Box>
	);
};

DevRevButton.defaultProps = {
	isLoading: false
};

export default DevRevButton;
